import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';

/**
 *
 * @description 특정 상황에서 열림 상태의 변경을 막을 수 있는 기능을 제공합니다.
 */
export const useClosableOnClickOpeningState = () => {
  const $ = _c(6);
  const openingState = useState(false);
  const [opened, setOpened] = openingState;
  const closableRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== opened) {
    t0 = () => {
      if (opened) {
        const handleClickedOutside = () => {
          if (closableRef.current) {
            setOpened(false);
          }
        };
        if (window) {
          window.addEventListener("click", handleClickedOutside);
          return () => window.removeEventListener("click", handleClickedOutside);
        }
      }
    };
    t1 = [opened, setOpened];
    $[0] = opened;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => {
      closableRef.current = value;
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== openingState) {
    t3 = {
      openingState,
      setClosableOnClick: t2
    };
    $[4] = openingState;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};